import { useRef, useState, useMemo } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_PRD3010_R01 } from "./Content_PRD3010_R01";
import { Info_PRD3010_R01 } from "./Info_PRD3010_R01";
import { SearchSection_PRD3010_R01 } from "./SearchSection_PRD3010_R01";
import { usePRD3010_R01Store } from "./Store_PRD3010_R01";
import { AgGridReact } from "ag-grid-react";
import { PRD3010_R01LotDto, PRD3010_R01DowntimeDto, PRD3010_R01Dto, PRD3010_R01HeaderDto, PRD3010_R01InspectDto, PRD3010_R01DetailDto } from "./Dto_PRD3010_R01";
import { Table_PRD3010_R01 } from "./Table_PRD3010_R01";
import { DetailTable_PRD3010_R01 } from "./DetailTable_PRD3010_R01";
import { LotTable_PRD3010_R01 } from "./LotTable_PRD3010_R01";
import ModalWrapper from "src/components/common/modal/ModalWrapper";
import { InspectTable_PRD3010_R01 } from "./InspectTable_PRD3010_R01";
import { blueButtonClass } from "src/components/common/common";
import { Modal_PRD3010_R01 } from "./Modal_PRD3010_R01";
export const Container_PRD3010_R01 = () => {

	const { 
		allCount,
		initData, 
		modalVisible,	setModalVisible,
		selectedPRD3010_R01LotList,
		PRD3010_R01LotList,
		syncInitialData,
	} = usePRD3010_R01Store();

	
	const { moneyCdList, vatTypeList } = useCommonCodeStore();
	const { tabList, setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'PRD3010_R01',
		type: 'width',
		storageKey: 'PRD3010_R01-split-width',
		min: 5,
		max: 80,
		default: 40
	} as const;
	const RESIZER_MODAL = {
		code: 'PRD3010_R01_modal',
		type: 'width',
		storageKey: 'PRD3010_R01-modal-split-width',
		min: 5,
		max: 80,
		default: 50
	} as const;

	const V_RESIZER = {
		code: 'PRD3010_R01',
		type: 'height',
		storageKey: 'PRD3010_R01-info-split-height',
		min: 5,
		max: 80,
		default: 60
	} as const;

	const RESIZER_LOT = {
		code: 'PRD3010_R01_lot',
		type: 'width',
		storageKey: 'PRD3010_R01-lot-split-width',
		min: 5,
		max: 80,
		default: 70
	} as const;

	const gridRef = useRef<AgGridReact<PRD3010_R01HeaderDto>>(null);
	const lotGridRef = useRef<AgGridReact<PRD3010_R01LotDto>>(null);
	const detailGridRef = useRef<AgGridReact<PRD3010_R01DetailDto>>(null);
	const inspectGridRef = useRef<AgGridReact<PRD3010_R01InspectDto>>(null);
	const downtimeGridRef = useRef<AgGridReact<PRD3010_R01DowntimeDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const modalRef = useRef<HTMLDivElement>(null);
	
	const infoRef = useRef<HTMLDivElement>(null);
	const lotInfoRef = useRef<HTMLDivElement>(null);
	const rightTopRef = useRef<HTMLDivElement>(null);
	const modalInfoRef = useRef<HTMLDivElement>(null);

	const isResizing = useRef(false);
	const isVResizing = useRef(false);
	const isLotResizing = useRef(false);
	const isResizing_modal = useRef(false);

	

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const { 
		splitValue: vSplitValue,
		handleMouseDown: handleVMouseDown,
	} = useMouseContent({
		resizer: V_RESIZER,
		isResizing: isVResizing,
		containerRef: infoRef,
		infoRef: rightTopRef
	});

	const { 
		splitValue: lotSplitValue,
		handleMouseDown: handleLotMouseDown,
		handleMouseUp: handleLotMouseUp
	} = useMouseContent({
		resizer: RESIZER_LOT,
		isResizing: isLotResizing,
		containerRef: rightTopRef,
		infoRef: lotInfoRef
	});

	const { 
		splitValue : splitValue_modal,
		handleMouseDown : handleMouseDown_modal,
		handleMouseUp : handleMouseUp_modal
	} = useMouseContent({
		resizer: RESIZER_MODAL,
		isResizing : isResizing_modal,
		containerRef : modalRef,
		infoRef : modalRef
	});
	

	const {
		handlePrintClick,
		handleExcelClick,
		fetchData,	
		defaultPRD3010_R01HeaderRow,
		defaultPRD3010_R01LotRow,
		defaultPRD3010_R01DetailRow,
		defaultPRD3010_R01InspectRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		handleFetchBomProductList,
		handleFetchLotList,
	} = Content_PRD3010_R01({
		gridRef,
		lotGridRef,
		detailGridRef,
		inspectGridRef,
		downtimeGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
		
	});

	useMemo(() => { syncInitialData(); }, []);

	const headerDefaultRow = useMemo(() => defaultPRD3010_R01HeaderRow(), [defaultPRD3010_R01HeaderRow]);
	const lotDefaultRow = useMemo(() => defaultPRD3010_R01LotRow(), [defaultPRD3010_R01LotRow]);
	const detailDefaultRow = useMemo(() => defaultPRD3010_R01DetailRow(), [defaultPRD3010_R01DetailRow]);
	const inspectDefaultRow = useMemo(() => defaultPRD3010_R01InspectRow(), [defaultPRD3010_R01InspectRow]);

	return <div className={`content-container`}>
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleCreateClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onPrintClick={handlePrintClick}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_PRD3010_R01 onEnterKeyDown={() => { fetchData(); }} />
		<Modal_PRD3010_R01  
			defaultPRD3010_R01HeaderRow={headerDefaultRow}
			inspectGridRef={inspectGridRef}
			defaultPRD3010_R01InspectRow={inspectDefaultRow}
			handleDeleteClick={handleDeleteClick}
		/>
		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0"
			ref={containerRef}>
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_PRD3010_R01 gridRef={gridRef} handleCreateClick={handleCreateClick} defaultPRD3010_R01HeaderRow={headerDefaultRow} />
			</div>
			{/* 리사이저 */}
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				data-comment="리사이저"
			/>
			<div className="h-full flex flex-col gap-[4px]" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
				<div className="w-full max-w-full flex flex-1 gap-[4px]" style={{ height: `${vSplitValue}%`, maxHeight: `${vSplitValue}%` }} ref={rightTopRef}>
					<div style={{ width: `${lotSplitValue}%` }}>
						<Info_PRD3010_R01 editable={false} 
							defaultPRD3010_R01HeaderRow={headerDefaultRow}
							handleFetchBomProductList={handleFetchBomProductList}
							handleFetchLotList={handleFetchLotList} />
					</div>
					<div
						className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
						onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleLotMouseDown('LR', e.nativeEvent)}
						data-comment="lot 리사이저"
					/>
					<div className="h-full max-h-full content-start " style={{ width: `${100 - lotSplitValue}%` }} ref={lotInfoRef}>	
						<LotTable_PRD3010_R01 lotGridRef={lotGridRef} defaultPRD3010_R01LotRow={lotDefaultRow} />
					</div>
				</div>
				{/* 리사이저 */}
				<div
					className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleVMouseDown("UD", e.nativeEvent) }
				/>
				<div style={{ height: `${100 - vSplitValue}%` }}>
					<DetailTable_PRD3010_R01 gridRef={detailGridRef} defaultPRD3010_R01DetailRow={detailDefaultRow} />
				</div>
			</div>
		</div>
		<Message />
	</div>
}